
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","height":"48","width":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('cloud-upload')]),_c('line',{attrs:{"x1":"12","y1":"23.25","x2":"12","y2":"14.25","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('polyline',{attrs:{"points":"8.25 18 12 14.25 15.75 18","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('path',{attrs:{"d":"M17.25,15.75h1.125a4.875,4.875,0,1,0-2.764-8.885A7.5,7.5,0,1,0,6.75,15.6","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}})])
          )
        }
      }
    